import { useCallback } from 'react';
import { Availability } from 'shared/types/product/InventoryQuery';
import { ProductQuery } from 'shared/types/query/ProductQuery';
import { GetEstimatedDeliveryDatePayload } from '@/sdk/composable-commerce/types/payloads/GetEstimatedDeliveryDatePayload';
import {
  AvailabilityPayload,
  WarrantyProductDataPayload,
} from '@/sdk/composable-commerce/types/payloads/productPayloads';
import { sdk } from 'sdk';
import { UseProductReturn } from './types';

const useProduct = (): UseProductReturn => {
  const query = useCallback(async (productQuery: ProductQuery) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.product.query({ limit: productQuery.limit, query: productQuery.query });
    return res;
  }, []);

  const getProductGroups = async (productQuery: any): Promise<Response> => {
    const extensions = sdk.composableCommerce;
    const result = await extensions.product.getProductGroups(productQuery);
    return result;
  };

  const getEstimatedDeliveryDate = async (payload: GetEstimatedDeliveryDatePayload): Promise<Response> => {
    const extensions = sdk?.composableCommerce;
    const result = await extensions.product.getEstimatedDeliveryDate(payload);
    return result;
  };

  const getAvailability = async (payload: AvailabilityPayload): Promise<Availability> => {
    const extensions = sdk?.composableCommerce;
    const res = await extensions.product.getAvailability(payload);
    if (!res.isError) {
      return res?.data;
    } else {
      throw new Error('Error retrieving Line Item Availibilty');
    }
  };

  const updateProductRules = async (productQuery: any): Promise<Response> => {
    const extensions = sdk.composableCommerce;
    const result = await extensions.product.updateProductRules(productQuery);
    if (result?.error?.message?.includes('503')) {
      throw new Error('Server Error: 503');
    }
    return result;
  };

  const getWarrantyProducts = async (payload: WarrantyProductDataPayload): Promise<Response> => {
    const extensions = sdk?.composableCommerce;
    const res = await extensions.product.getWarrantyProducts(payload);
    if (!res.isError) {
      return res?.data;
    } else {
      throw new Error('Error retrieving Warranty Product data');
    }
  };
  return {
    query,
    getProductGroups,
    getEstimatedDeliveryDate,
    getAvailability,
    updateProductRules,
    getWarrantyProducts,
  };
};

export default useProduct;
